import type { SVGProps } from 'react';

interface CancelIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function CancelIcon({ className, ...props }: CancelIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="7 7 10.01 10.01"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M7.75613 15.2986L11.0566 11.9981L7.75797 8.69955C7.49772 8.4393 7.49793 8.01711 7.75797 7.75674C8.01832 7.49639 8.44043 7.49639 8.70078 7.75674L12 11.056L15.2992 7.75674C15.5596 7.49639 15.9817 7.49639 16.242 7.75674C16.5021 8.01711 16.5023 8.4393 16.242 8.69955L12.9428 11.9988L16.2433 15.2992C16.5036 15.5596 16.5036 15.9817 16.2433 16.242C15.9829 16.5021 15.5607 16.5023 15.3004 16.242L11.9994 12.941L8.69894 16.2414C8.43859 16.5018 8.01648 16.5018 7.75613 16.2414C7.49609 15.981 7.49588 15.5588 7.75613 15.2986Z" fill="currentColor"/>
    </svg>
  );
}
